import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CertificateOfNonConfusionComponent } from './certificate-of-non-confusion/certificate-of-non-confusion.component';
import { IssuanceCodeCertificateComponent } from './issuance-code-certificate/issuance-code-certificate.component';
import { BankCertificateComponent } from './bank-certificate/bank-certificate.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BankCertificateInfoComponent } from './bank-certificate-info/bank-certificate-info.component';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RequiredDocumentsComponent } from './required-documents/required-documents.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { MaterialModule } from './material.module';
import { NotesDialogComponent } from './components/notes-dialog/notes-dialog.component';
import { CustomDateInputComponent } from './custom-date-input/custom-date-input.component';
import { ValidatePhoneNumberDirective } from './directives/validate-phone-number.directive';
import { NoSpecialCharsDirective } from './directives/no-special-chars.directive';

// Shared Module - exports common Angular modules for use throughout the app
@NgModule({
  declarations: [
    CertificateOfNonConfusionComponent,
    IssuanceCodeCertificateComponent,
    BankCertificateComponent,
    BankCertificateInfoComponent,
    RequiredDocumentsComponent,
    FileUploadComponent,
    NotesDialogComponent,
    CustomDateInputComponent,
    ValidatePhoneNumberDirective,
    NoSpecialCharsDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  exports: [
    // Re-export common Angular modules
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    // Export shared components
    CertificateOfNonConfusionComponent,
    IssuanceCodeCertificateComponent,
    BankCertificateComponent,
    BankCertificateInfoComponent,
    RequiredDocumentsComponent,
    FileUploadComponent,
    CustomDateInputComponent,
    ValidatePhoneNumberDirective,
    NoSpecialCharsDirective
  ],
})
export class SharedModule { }
